import { Component } from '@angular/core';
import { UiCakeCounterBaseComponent } from './ui-cake-counter-base.component';

/** Difference between ui-cake-counter and ui-single-pieces-counter:
 * ui-cake-counter is used in cake-builder footer, when cake-builder first init it should have some quantity
 * for product (it maybe increment or minQuantity) it is made for user usability,
 * it is better when user don't start with zero product quantity, while ui-single-pieces-counter is used on products overview
 * and in cake-multiple-variant-section where products quantity should be start with zero value, that's why
 * shiftCount and control disable logic a bit different
 * */

@Component({
  standalone: false,
  selector: 'ui-single-pieces-counter',
  templateUrl: './ui-cake-counter.component.html',
  styleUrls: ['./ui-cake-counter.component.scss']
})
export class UiSinglePiecesCounterComponent extends UiCakeCounterBaseComponent {
  public minusDisablingCheck() {
    return this.count === 0;
  }

  public shiftCount(isIncrease: boolean) {
    const shift = this._getShift(isIncrease);
    const count = Math.max(0, this.count + shift);

    if (isIncrease) {
      this.count = this._hasMaxCount() && this.maxCount < count ? this.maxCount : count;
    } else {
      this.count = this.minCount > count && count !== 0 ? this.minCount : count;
    }

    this.setCount(this.count);
  }

}
